import "./App.css";
import {Fragment} from "react";
import {Routes, Route} from "react-router-dom";
import Navbar from "./routes/navbar/navbar.component";
import Authentication from "./routes/auth/authentication.component";
import Blogging from "./routes/blog/blogging.component";
import BlogPost from "./routes/blog/blog-post.component";
import BlogEditor from "./routes/blog/blog-editor.component";
import RootPage from "./routes/root/root-page.component";
import ChatBot from "./components/chat-bot/chat-bot.component";

function App() {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Navbar/>}>
          <Route index element={<RootPage/>}/>
          <Route path="/login" element={<Authentication/>}/>
          <Route path="/blog" element={<Blogging/>}/>
          <Route path="/blog/new" element={<BlogEditor/>}/>
          <Route path="/blog/:slug" element={<BlogPost/>}/>
          <Route path="/blog/:slug/edit" element={<BlogEditor/>}/>
        </Route>
      </Routes>
      <ChatBot/>
    </Fragment>
  );
}

export default App;
